import styled from 'styled-components'

export const ContainerStyled = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1296px;
  width: 100%;
  margin-top: 140px;

  h1 {
    width: fit-content;
  }

  h2 {
    width: fit-content;
  }

  .mobileEx {
    display: none;

    @media (max-width: 768px) {
      display: block;
      justify-self: center;

      img {
        max-width: 280px;
      }
    }
  }

  .desktopEx {
    display: block;

    @media (max-width: 768px) {
      display: none;
    }
  }

  p {
    width: fit-content;
  }

  span {
    width: fit-content;
    display: flex;
    gap: 4px;
    font-size: 16px;
    line-height: 24px;
    color: #7077ec;
    font-family: 'Bai Jamjuree', serif;
    font-weight: 500;
  }
  p {
    width: fit-content;
    max-width: 1296px;
    color: #f3f3f3;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    font-family: 'Assistant', serif;
  }

  img {
    width: 438px;
  }
`
export const ContainerDesc = styled.div`
  margin-top: 64px;

  h2 {
    max-width: 1296px;
    width: fit-content;
  }

  p {
    width: fit-content;
    max-width: 1296px;

    @media (max-width: 768px) {
      padding-right: 0;
    }
  }

  .LinkExterno {
    color: #c6f688;
    font-weight: normal;
    font-family: 'Assistant', serif;
  }

  span {
    a {
      color: #c6f688;
      font-weight: 400;
    }
  }

  .validacao {
    ul {
      grid-template-columns: repeat(3, 1fr);

      .validation {
        width: 416px;
        height: 160px;
        padding: 24px;
        border: 1px solid #a8d65f;
        border-radius: 16px;
        background: #202020;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        transition: 0.25s ease;

        p {
          font-size: 13px;
          font-weight: 400;
          line-height: 1.3;
          margin-bottom: 0;
          font-family: 'Bai Jamjuree', sans-serif;
        }

        span {
          margin-top: 16px;
          color: #b8e86b;
          font-size: 12px;
          font-weight: 400;
        }

        .span2 {
          margin-top: 56px;
        }
      }
    }
  }
  .processo {
    margin-top: 104px;
    max-width: 1296px;

    h3 {
      margin-bottom: 40px;
      font-size: 32px;
      line-height: 40px;
      font-family: 'Bai Jamjuree', sans-serif;
      font-weight: 300;
    }

    ul {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 20px;
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .process {
      width: 276px;
      height: 160px;
      padding: 24px;
      border: 1px solid #a8d65f;
      border-radius: 16px;
      background: #202020;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      transition: 0.25s ease;

      &:hover {
        border-color: #b8e86b;
        transform: translateY(-4px);
      }

      img {
        width: 28px;
        height: 28px;
        object-fit: contain;
        margin-bottom: 22px;
      }

      p {
        color: #f5f5f5;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.3;
        font-family: 'Bai Jamjuree', sans-serif;
      }
    }

    @media (max-width: 992px) {
      ul {
        grid-template-columns: repeat(1, 1fr);
        .process {
          width: 100%;
        }
      }
    }

    @media (max-width: 576px) {
      ul {
        grid-template-columns: 1fr;
      }
    }
  }
`
export const ContainerStyledImgs = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  max-width: 1296px;
  margin-bottom: 32px;

  p {
    margin-bottom: 10px;
  }

  @media (max-width: 1024px) {
    display: block;
    justify-self: center;
  }

  .desktopSocio {
    max-width: 934px;
    width: 100%;
    @media (max-width: 1024px) {
      display: none;
    }
  }
  .mobileSocio {
    display: none;
    max-width: 400px;
    width: fit-content;

    @media (max-width: 1024px) {
      margin-top: 24px;
      display: block;
    }
    @media (max-width: 425px) {
      width: 280px;
    }
  }
  img {
    max-width: 935px;
    @media (max-width: 1024px) {
      margin-top: 24px;
      display: block;
      justify-self: center;
    }
  }
`
export const IframeStyled = styled.div`
  max-width: 1296px;
  margin: 0 auto;
  display: flex;
  justify-content: center;

  iframe {
    border: 1px solid rgba(0, 0, 0, 0.08);
    width: 996px;
    min-height: 925px;
  }

  @media (max-width: 425px) {
    max-width: 280px;
    width: 100%;
    margin: 0 auto;

    iframe {
      width: 100%;
      height: 280px;
      margin: 0;
      border: 1px solid rgba(0, 0, 0, 0.1);
    }
  }
`
